import React, { useEffect, useState } from "react";
import { useTranslation } from "../../../context/TranslationContext";

const PageTwo = ({ formdata, setformdata, validSteps, setvalidSteps }) => {
  const {
    getOfferStep2Title,
    getOfferStep2Option1,
    getOfferStep2Option2,
    getOfferStep2Option3,
  } = useTranslation();
  const [priceType, setPriceType] = useState(formdata.priceType);

  useEffect(() => {
    setformdata({ ...formdata, priceType: priceType });
    setvalidSteps({ ...validSteps, 2: priceType > 0 });
  }, [priceType]);
  return (
    <div className="flex flex-col mb-7">
      <div className="flex justify-center mb-6">
        <span className="md:text-25 text-15 text-black font-medium">
          {getOfferStep2Title}
        </span>
      </div>
      <div className="grid sm:grid-cols-3 ml:grid-cols-2 grid-cols-1 gap-6">
        <label className="w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer">
          {getOfferStep2Option1}
          <input
            type="radio"
            value="1"
            className="w-8 h-8"
            onChange={() => setPriceType(1)}
            checked={priceType == 1}
          />
        </label>
        <label className="w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer">
          {getOfferStep2Option2}
          <input
            type="radio"
            value="2"
            className="w-8 h-8"
            onChange={() => setPriceType(2)}
            checked={priceType == 2}
          />
        </label>
        <label className="w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer">
          {getOfferStep2Option3}
          <input
            type="radio"
            value="3"
            className="w-8 h-8"
            onChange={() => setPriceType(3)}
            checked={priceType == 3}
          />
        </label>
      </div>
    </div>
  );
};

export default PageTwo;
